import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Brand from '../Brand';
import Li from './li-logo.png';

import s from './Footer.css';

class Footer extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={s.container}>
          <div className={s.row}>
            <div className={s.col}>
              <Brand inverse />

              <p className={s.lead}>
                {`En hjälp för dig som vill använda Livsmedelsverkets
                  kostråd i din märkning och marknadsföring.`}
              </p>
              <p>
                {'Livsmedelsföretagen'}
                <br />
                {'Box 55 680, 102 15 Stockholm'}
                <br />
                {'Besöksadress: Storgatan 19'}
                <br />
                {'08-762 65 00 (växel)'}
              </p>
              <p>
                <a className={s.link} href="mailto:info@li.se">
                  {'info@li.se'}
                </a>
                <br />
                <a
                  className={s.link}
                  rel="noopener noreferrer"
                  href="https://www.livsmedelsforetagen.se"
                  target="_blank"
                >
                  {'www.livsmedelsforetagen.se'}
                </a>
              </p>
            </div>

            <div className={s.col}>
              <div className={s.li}>
                <a
                  rel="noopener noreferrer"
                  href="https://livsmedelsforetagen.se"
                  target="_blank"
                >
                  <img
                    className="img-responsive"
                    alt="Livsmedelsföretagens logotyp"
                    src={Li}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js